/* @flow */
export const Experiments = {
  TEST: {
    // needed for Experimentation-test
    apiKey: '1080.apr.web.unit_test',
    validVariants: ['control', 'someValid'],
  },
  CHAT_DEPROXY: {
    apiKey: '2018.feb.web.chat_stream_deproxy',
    validVariants: ['control', 'deproxy'],
  },
  INDIVIDUAL_PLAN: {
    apiKey: '2018.dec.canada_individual_plans',
    validVariants: ['control', 'individual_plan'],
  },
};
